import { ref } from 'vue'

interface PlantNameState {
  [key: string]: string | undefined
}

const plantNameState = ref<PlantNameState>({})

export default function usePlantName(projectId: Ref<string>) {
  const setPlantName = (plantName: string) => {
    plantNameState.value[projectId.value] = plantName
  }

  const getPlantName = (): string | undefined => {
    return plantNameState.value[projectId.value]
  }

  const clearPlantName = () => {
    plantNameState.value[projectId.value] = undefined
  }

  return {
    setPlantName,
    getPlantName,
    clearPlantName,
  }
}
